<template>
  <div>
    <popup
      ref="popup"
      round
      v-model="show"
      position="bottom"
      :close-on-click-overlay="false"
      :lazy-render="false"
    >
      <div class="popup-title">
        <span class="popup-cancel" @click="popupCancel">取消</span>
        <span class="popup-title-text">请选择</span>
        <span class="popup-confirm" @click="popupConfirm">确定</span>
      </div>
      <picker
        ref="datetime"
        :columns="columns"
        :show-toolbar="false"
        visible-item-count="5"
      >
        <template v-slot:option="item">
          <div class="picker-item">
            <div>{{ item.title }}</div>
          </div>
        </template>
      </picker>
    </popup>
  </div>
</template>

<script>
/**
@description:选择时间组件
@createTime:2021-09-21
@create:wq
*/
import { Popup, Picker } from "vant";

export default {
  name: "",
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    date: {
      type: String,
      default: "请选择",
    },
    type: {
      type: String,
      default: "1",
    },
  },
  model: {
    prop: "show",
    event: "changeShow",
  },

  components: { Popup, Picker },
  data() {
    return {
      columns: [],
    };
  },
  computed: {},
  watch: {
    show() {
      if (this.date !== "请选择") {
        // const arr = this.date.split("-");
        this.$refs.datetime.setValues([this.date]);
      }
    },
  },
  mounted() {},
  created() {
    // console.log(this.type);
    if (this.type != 3 && this.type != 4) {
      this.getList();
    } else if (this.type == 4) {
      this.columns = [
        { title: "鼠" },
        { title: "牛" },
        { title: "虎" },
        { title: "兔" },
        { title: "龙" },
        { title: "蛇" },
        { title: "马" },
        { title: "羊" },
        { title: "猴" },
        { title: "鸡" },
        { title: "狗" },
        { title: "猪" },
      ];
    } else {
      this.columns = [
        { title: "A" },
        { title: "B" },
        { title: "O" },
        { title: "AB" },
      ];
    }
  },
  methods: {
    getList() {
      this.columns = [
        { title: "白羊座" },
        { title: "金牛座" },
        { title: "双子座" },
        { title: "巨蟹座" },
        { title: "狮子座" },
        { title: "处女座" },
        { title: "天秤座" },
        { title: "天蝎座" },
        { title: "射手座" },
        { title: "摩羯座" },
        { title: "水瓶座" },
        { title: "双鱼座" },
      ];
      // this.api.fortuneList({ type: this.type }).then((res) => {
      //   console.log(res.data);
      //   this.columns = res.data;
      // });
    },
    popupCancel() {
      this.$emit("changeShow", false);
    },
    popupConfirm() {
      const data = this.$refs.datetime.getValues()[0];
      this.$emit("changeShow", false);
      this.$emit("confirm", { date: data });
    },
  },
};
</script>
<style lang="scss" scoped>
.popup-title {
  width: 100%;
  height: 50px;
  background: #f6f6f6;
  font-size: 15px;
  font-weight: 500;
  color: #333333;
  box-sizing: border-box;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .popup-cancel {
    color: #666666;
  }
  .popup-title-text {
    font-weight: bold;
  }
  .popup-confirm {
  }
}
.switch-gy {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e3e3e3;
  box-sizing: border-box;
  padding: 0 15px;

  .switch-gy-tilte {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
  }
  .switch {
    width: 120px;
    height: 30px;
    background: #f6f6f6;
    border-radius: 15px;
    overflow: hidden;
    display: flex;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    border: 1px solid #e3e3e3;
    > span {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .action {
      color: #ffffff;
      background: #34c290;
    }
  }
}
.picker-item {
  width: 100%;
  display: flex;
  align-items: center;
  > div {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
